/**
 * Distance helpers for the Find-a-charger page.
 *
 * `haversineKm` returns straight-line kilometres between two
 * WGS84 coordinates. Callers must guard against null/NaN inputs
 * before invoking — this file intentionally has no fallback so a
 * missing coordinate surfaces as "no distance" in the UI rather
 * than as `0 km`.
 */

const R_KM = 6371;

function toRad(deg) {
  return (deg * Math.PI) / 180;
}

export function isValidCoord(v) {
  return typeof v === 'number' && Number.isFinite(v);
}

export function haversineKm(a, b) {
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const s =
    Math.sin(dLat / 2) ** 2 +
    Math.sin(dLng / 2) ** 2 * Math.cos(lat1) * Math.cos(lat2);
  return 2 * R_KM * Math.asin(Math.min(1, Math.sqrt(s)));
}

export function formatKm(km) {
  if (!Number.isFinite(km)) return null;
  if (km < 10) return `${km.toFixed(1)} km`;
  return `${Math.round(km)} km`;
}
